/* eslint-disable arrow-body-style */
import { API, Auth, Logger } from 'aws-amplify';

const logger = new Logger('P3ApiService');
const P3_API_NAME = 'P3ApiProxy';

/**
 * Request Options to include authorization headers on all requests
 */
const requestOptions = () => {
  logger.debug('requestOptions..');
  return Auth.currentAuthenticatedUser()
    .then((user) => {
      return {
        headers: {
          'Content-Type': 'application/json',
          'idToken': `${user.signInUserSession.idToken.jwtToken}`,
        },
      };
    })
    .catch((error) => {
      logger.error('User is not authenticated ', error);
      throw error;
    });
};

/**
 * Request Wrapper to call the request options on all requests
 * @param {*} request
 */
const requestWrapper = (request) => {
  return requestOptions().then((options) => request(options));
};

/**
 * Return a page of vendors
 * this service returns a sorted and filtered list of vendor to make it
 * easier for the client to consume the result
 * @param {*} params
 */
const getVendors = (params = { size: 2500, sort: 'description,asc' }) => {
  return requestWrapper((options) => {
    // set query params if any
    Object.assign(options, { queryStringParameters: params });
    // make api request, then filter the result to return only active ones
    return API.get(P3_API_NAME, '/vendors', options).then((result) => {
      return result.filter(
        (v) => (!v.inactive && !v.description.includes('DO NOT USE'))
      );
    });
  });
};

const getCategories = (params = { size: 200, sort: 'name,asc' }) => {
  return requestWrapper((options) => {
    // set query params if any
    Object.assign(options, { queryStringParameters: params });
    // make api request, then filter the result to return only active ones
    return API.get(P3_API_NAME, '/categories', options);
  });
};

/**
 * Return a page of locations
 * this service returns a list of Locations, by default the list is sorted by code
 * @param {*} params
 */
const getLocations = (params = { size: 200, sort: 'code,asc' }) => {
  return requestWrapper((options) => {
    // set query params if any
    Object.assign(options, { queryStringParameters: params });
    // make api request, then filter the result to return only active ones
    return API.get(P3_API_NAME, '/locations', options);
  });
};

/**
 * Return a page of Country of Origins
 * this service returns a list of Country of Origins, by default the list is sorted by name
 * @param {*} params
 */
const getCountryOfOrigins = (params = { size: 200, sort: 'name,asc' }) => {
  return requestWrapper((options) => {
    // set query params if any
    Object.assign(options, { queryStringParameters: params });
    // make api request, then filter the result to return only active ones
    return API.get(P3_API_NAME, '/countryOfOrigins', options);
  });
};

/**
 * Return a page of Customers
 * this service returns a list of Customers, by default the list is sorted by name
 * @param {*} params
 */
const getCustomers = (params = { size: 1000, sort: 'description,asc' }) => {
  return requestWrapper((options) => {
    // set query params if any
    Object.assign(options, { queryStringParameters: params });
    // make api request, then filter the result to return only active ones
    return API.get(P3_API_NAME, '/customers', options);
  });
};

export {
  requestWrapper,
  getVendors,
  getCategories,
  getLocations,
  getCountryOfOrigins,
  getCustomers,
};
